import { render } from "./TextBlock.vue?vue&type=template&id=2a09bf49"
import script from "./TextBlock.vue?vue&type=script&lang=js"
export * from "./TextBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/TextBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a09bf49"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a09bf49', __exports__)) {
    api.reload('2a09bf49', __exports__)
  }
  
  module.hot.accept("./TextBlock.vue?vue&type=template&id=2a09bf49", () => {
    api.rerender('2a09bf49', render)
  })

}


export default __exports__